import { render, staticRenderFns } from "./StatusEventoBilhete.vue?vue&type=template&id=282f906d&scoped=true"
import script from "./StatusEventoBilhete.vue?vue&type=script&lang=js"
export * from "./StatusEventoBilhete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f906d",
  null
  
)

export default component.exports